











import Vue from 'vue';
import PAccordion from './p-accordion.vue';

type Accordion = InstanceType<typeof PAccordion>;

export default Vue.extend({
  name: 'PAccordionGroup',
  props: {

  },
  data: () => ({
    children: [] as Vue[],
  }),
  methods: {
    onAccordionInput(accordion: Accordion, expanded: boolean) {
      if (!expanded) {
        return;
      }
      this.children.forEach((child) => {
        const currAccordion = child.$parent as Accordion;
        if (currAccordion === accordion) {
          return;
        }
        if (currAccordion.expanded !== false) {
          currAccordion.$emit('input', false);
        }
      });
    },
    onRegisterAccordion(child: Vue) {
      const accordion = child.$parent as Accordion;
      accordion.$watch('value', () => this.onAccordionInput(accordion, accordion.expanded));
    },
    onUnregisterAccordion(child: Accordion) {
      child.$off('input');
    },
  },

});
